import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function SetupFeePage() {
  const { user, loading, logout } = useAuth();
  const [busy, setBusy] = useState(false);
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.setup_fee_paid) return <Navigate to={user.has_wedding || ["vendor", "planner"].includes(user.role) ? "/dashboard" : "/onboarding"} replace />;
  async function pay() {
    setBusy(true);
    try { const { data } = await api.post("/payments/checkout", { plan_id: "setup_fee", origin_url: window.location.origin }); window.location.href = data.url; }
    catch (e) { toast.error(formatApiError(e)); setBusy(false); }
  }
  return (
    <div className="min-h-screen bg-[var(--bg)] flex items-center justify-center p-6" data-testid="setup-fee-page">
      <div className="max-w-md w-full bg-white border border-[var(--line)] rounded-[2rem] p-8 text-center">
        <img src="/brand/logo-full.png" alt="LockedInForever" className="h-20 mx-auto" />
        <p className="text-[11px] uppercase tracking-[0.2em] text-[var(--muted)] mt-6">Last step · one-time</p>
        <h1 className="font-serif font-light text-4xl mt-1">Account setup</h1>
        <p className="font-serif text-5xl mt-4" data-testid="setup-fee-amount">$9.99</p>
        <p className="text-sm text-[var(--muted)] mt-3">A one-time fee that activates your account, your private dashboard and secure storage. You won't be charged it again.</p>
        <button onClick={pay} disabled={busy} className="btn-gold w-full justify-center mt-6" data-testid="setup-fee-pay-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />} Pay $9.99 securely</button>
        <button onClick={logout} className="text-xs text-[var(--muted)] mt-4 underline">Sign out</button>
      </div>
    </div>
  );
}
